// extracted by mini-css-extract-plugin
var _1 = "renderHighlight-module__searchHighlight--JFcrr";
export { _1 as "searchHighlight" }
